import React from "react";
import { Form, Flex, Select, Table, Button, message, Modal } from "antd";
import { CopyOutlined } from '@ant-design/icons';
import { Input } from "antd";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { safeCall } from "../../utils/jsbridge"; // 添加这一行
import { getCurrentShopId } from "../shop/get-current-shop";
import SwitchShop from '../shop/switch-shop';

export default (props) => {
    const [dataSource, setDataSource] = React.useState({});
    const [form] = Form.useForm();
    const [page, setPage] = React.useState(1);
    const [total, setTotal] = React.useState(0);
    const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);

    const onSelectChange = newSelectedRowKeys => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    // React.useEffect(() => {
    //     form.setFieldsValue({
    //         city: '杭州',
    //     });
    // }, []);

    const cities = [
        { label: '杭州', value: '杭州' },
        { label: '长沙', value: '长沙' },
    ]

    const columns = [
        {
            title: '区',
            dataIndex: 'adname',
            key: 'adname',
        },
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return (
                    <div>
                        {text} 
                        {(typeof record.tel === 'string' && !!record.tel) && <CopyToClipboard style={{margin: '0 0 0 8px'}} text={text} onCopy={() => message.success('复制成功')}>
                            <a style={{ fontSize: '12px'}}><CopyOutlined /></a>
                        </CopyToClipboard>}
                    </div>
                )
            }
        },
        {
            title: '手机号',
            fixed: 'right',
            dataIndex: 'tel',
            key: 'tel',
            render: (text, record) => {
                return (
                    <div>
                        {(typeof text === 'string' && !!text) && text.split(';').map((item) => <div key={item}>
                            <a onClick={() => safeCall(item)}>{item}</a>
                        </div>)}
                        {/* {(typeof text === 'string' && !!text) && <CopyToClipboard text={text} />} */}
                    </div>
                )
            }
       },
    ];

    const onPageChange = async (value) => {
        console.log('onPageChange', value);
        search(value);
    }

    const onCityChange = (value) => {
        console.log('onCityChange', value);
        form.setFieldsValue({
            city: value,
        });

    }

    const onSearch = () => {
        search({current: 1});
    }

    const search = async ({current = 1}) => {
        const data = form.getFieldsValue();
        data.page = current;
        console.log('params', data);

        const params = new URLSearchParams(data);

        const response = await fetch(`/api/customer/discover?${params}`, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const result = await response.json();
        console.log('result', result);

        if(result.success) {
            const count = +result.data?.count;
            setPage(current);
            setDataSource(result.data);
            if(count > 0) setTotal(count);
            console.log('setDataSource', +result.data?.count);
        }
    }

    const handleAddCustomer = async () => { 
        const customers = [];
        selectedRowKeys.forEach(key => {
            const customer = dataSource?.pois?.find(c => c.id === key);
            // 从0571-85058879,18958011577中解析手机号码
            
            if(customer) {
                const phoneNo = (typeof customer.tel === 'string') ? customer?.tel?.match(/1\d{10}/)?.[0] : '';
                customers.push({
                    id: customer.id,
                    username: customer.name,
                    phoneNo: phoneNo || null,
                    province: customer.pname,
                    city: customer.cityname,
                    contry: customer.adname,
                    address: customer.address,
                    remark: '开发客户'
                });
            }
        });

        console.log('customers', customers);

        if(customers.length) {
            const shopId = await getCurrentShopId();
            const response = await fetch(`/api/customer/batch-create?shopId=${shopId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(customers)
            });

            const result = await response.json();
            if(result.success) {
                const {data = {}} = result;
                const { failed = 0, success = 0, skipped = 0 } = data;
                Modal.error({
                    title: '加入成功',
                    content: <div>成功添加：{success}个；失败：{failed}个；跳过：{skipped}个体</div>,
                });
            } else {
                message.error('加入失败');
            }
        }
    };

    return (
        <div>
            <main className="admin-main-content admin-content">
                <SwitchShop />
                
                <h2 className="admin-page-title">客户开发</h2>
                
                <div className="admin-form-container mb-4">
                    <Form form={form} layout="vertical">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                            <Form.Item label="城市" name={'city'}>
                                {/* <Select options={cities} onChange={onCityChange} /> */}
                                <Input className="admin-form-input" placeholder="请输入城市" />
                            </Form.Item>

                            <Form.Item label="关键词" name={'keywords'} rules={[ { required: true, message: '请输入关键词' } ]}>
                                <Input className="admin-form-input" placeholder="软装清洗" />
                            </Form.Item>
                        </div>

                        <div className="flex flex-wrap gap-2 mt-4">
                            <Button onClick={onSearch} type="primary" className="min-h-touch">
                                搜索
                            </Button>
                            <Button 
                                onClick={handleAddCustomer} 
                                disabled={selectedRowKeys.length <=0}
                                className="min-h-touch"
                            >
                                添加到客户管理
                            </Button>
                        </div>
                    </Form>
                </div>

                {/* 批量操作提示 */}
                {selectedRowKeys.length > 0 && (
                    <div className="mb-4 py-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between">
                        <span className="text-sm text-blue-700">
                            已选择 <strong>{selectedRowKeys.length}</strong> 项
                        </span>
                        <Button 
                            size="small"
                            onClick={() => setSelectedRowKeys([])}
                        >
                            取消选择
                        </Button>
                    </div>
                )}

                {/* 数据表格 */}
                <Table 
                    rowSelection={rowSelection}
                    onChange={onPageChange} 
                    rowKey='id'
                    size="small" 
                    columns={columns} 
                    dataSource={dataSource.pois || []} 
                    pagination={{total, pageSize: 25, current: page, simple: true, showSizeChanger: false}}
                    scroll={{ x: 'max-content' }}
                />
            </main>
        </div>
    )
}